/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const LinkStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M11 6.00002L13.575 3.42502C14.511 2.51149 15.7671 2.00012 17.075 2.00012C18.3829 2.00012 19.639 2.51149 20.575 3.42502C21.4886 4.36102 21.9999 5.61711 21.9999 6.92502C21.9999 8.23294 21.4886 9.48902 20.575 10.425L18 13M13 18L10.425 20.575C9.48902 21.4886 8.23294 21.9999 6.92502 21.9999C5.61711 21.9999 4.36102 21.4886 3.42502 20.575C2.51149 19.639 2.00012 18.3829 2.00012 17.075C2.00012 15.7671 2.51149 14.511 3.42502 13.575L6.00002 11M8.00002 16L16 8.00002"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
});

export { LinkStrokeIcon };
